
import { Component, Vue } from "vue-property-decorator";
import {Message, Row} from "element-ui";
import {
  addRemark, cancelPrepareGoods,
  confirmException,
  confirmStockUp,
  confirmTransship,
  getContainerTypeConfigurationInfoForWarehouse,
  getHenganLoadingPlanPackingInfos,
  getHenganLoadingPlansForWarehouse,
  getHenganLoadingProblemPackingInfos,
  getTransshipDeliveryInfo,
  getTransshipInfoForWarehouse,
  saveTransshipDeliveryInfo,
} from "@/api/hengan-loading-plan";
import Pagination from "@/components/Pagination/index.vue";
import { IUserModel } from "@/api/types";
import { ShippingOrderModel } from "@/model/shipping-order";
import ConfigContainerTypeComponent, {
  ContainerTypeConfigurationInfo,
} from "@/views/components/ConfigContainerTypeComponent.vue";
import CustomsPackingInfoInTable from "@/views/components/CustomsPackingInfoInTable.vue";
import { formatJson } from "@/utils";
import { exportJson2Excel } from "@/utils/excel";
import {
  deleteLoadingInfosForWarehouse,
  saveLoadingInfosForWarehouse,
} from "@/api/loading-info";
import { cloneDeep, pull, remove } from "lodash";
import {
  CustomsPackingModel,
  LoadingInfo,
  PackingVolume,
} from "@/model/HenganLoadingPlanModels";
import ConfirmStockUpComponent, {
  HenganLoadingPlanPackingInfoResponse,
} from "@/views/components/ConfirmStockUpComponent.vue";
import * as jasmine from "jasmine-core";
import any = jasmine.any;
import Template from "@/views/system-management/template/index.vue";

@Component({
  name: "HenganLoadingPlanForWarehouse",
  components: {
    ConfirmStockUpComponent,
    ConfigContainerTypeComponent,
    Template,
    CustomsPackingInfoInTable,
    Pagination,
  },
})
export default class extends Vue {
  private henganLoadingPlans:any = [];
  private logisticsSpecialist: IUserModel[] = [];
  private shippingOrders: ShippingOrderModel[] = [];
  private transshipDeliveryInfoDialogVisible = false;
  private editTransship = false;
  private currentRow: HenganLoadingPlanTableRowData =
    new HenganLoadingPlanTableRowData();
  private currentTransshipDeliveryInfo: TransshipDeliveryInfo =
    new TransshipDeliveryInfo();

  private total = 0;
  private listQuery = {
    pageNumber: 1,
    pageSize: 20,
    customerAbbreviationOrCode: null,
    code: null,
    states: null,
    startDate: null,
    endDate: null,
    dateRange: null,
  };

  created() {
    this.getList();
  }

  private getHiddenColumns() {
    if (
      this.$route.meta.buttonCodes &&
      Array.isArray(this.$route.meta.buttonCodes)
    ) {
      return this.$route.meta.buttonCodes.includes("actionColumns");
    }
  }

  public async getList() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    } else {
      this.listQuery.startDate = null;
      this.listQuery.endDate = null;
    }
    const params = { ...this.listQuery };
    params.dateRange = null;
    getHenganLoadingPlansForWarehouse(params)
      .then((res: any) => {
        this.total = res.total;
        this.henganLoadingPlans = res.content;
        this.henganLoadingPlans.map((item,index) => {item.sn = index + 1})
      })
      .catch((error) => {
        Message.error({
          message: error.message,
          duration: 2000,
        });
      });
  }

  // 添加备注
  private addRemarkDialogVisible = false;

  private showAddRemarkDialog(row: HenganLoadingPlanTableRowData) {
    this.currentRow = cloneDeep(row);
    this.addRemarkDialogVisible = true;
  }

  private async confirmTransship() {
    await confirmTransship(
      this.henganLoadingPlanTransshipInfo.henganLoadingPlanId
    ).then(async res => {
      this.configTransshipDeliveryDialogVisible = false;
      this.henganLoadingPlanTransshipInfo = new HenganLoadingPlanTransshipInfo();
      await this.getList();
    }).catch(err => {
      console.log(err);
    });
  }

  private async doAddRemark() {
    await addRemark(this.currentRow.id, { remark: this.currentRow.remark });
    this.addRemarkDialogVisible = false;
    await this.getList();
  }

  private checkImages(row: HenganLoadingPlanTableRowData) {
    this.$router.push({
      name: "ImageManagement",
      params: { bizType: "hengan-loading-plan", objectId: row.id },
    });
  }

  private checkDetail(row: HenganLoadingPlanTableRowData) {
    this.$router.push({
      name: "HenganLoadingPlanDetailForWarehouse",
      params: { henganLoadingPlanId: row.id },
    });
  }

  private checkTransship() {
    this.$router.push({
      name: "Transship",
    });
  }

  private downloadList() {
    const data = this.henganLoadingPlans.map((value) => {
      return {
        isTransshipDelivery: value.transshipDelivery ? "是" : "否",
        stateDesc: value.state.desc,
        ...value,
      };
    });
    const headers = [
      "出库计划单号",
      "客户简称",
      "创建日期",
      "是否驳货",
      "状态",
      "物流员",
      "备注",
    ];
    const fieldNames = [
      "code",
      "customerAbbr",
      "createdAt",
      "isTransshipDelivery",
      "stateDesc",
      "logisticsClerkName",
      "remark",
    ];
    exportJson2Excel(
      headers,
      formatJson(fieldNames, data),
      `出库计划（仓库）-${new Date()}`
    );
  }

  private showEditTransshipDeliveryInfoDialog(
    row: HenganLoadingPlanTableRowData
  ) {
    this.currentRow = row;
    this.currentTransshipDeliveryInfo = new TransshipDeliveryInfo();
    this.transshipDeliveryInfoDialogVisible = true;

    getTransshipDeliveryInfo(row.id).then((res: any) => {
      this.currentTransshipDeliveryInfo = res;
    });
  }

  private checkProblemCustomsPackingImageAPP(customsPackingId: string) {
    this.confirmStockUpDialogVisible = false;
    this.$router.push({
      name: "ImageManagement",
      params: {
        bizType: "customs-packing",
        objectId: customsPackingId,
      },
    });
  }

  private submitTransshipDeliveryInfo() {
    if (!this.currentTransshipDeliveryInfo.warehouseAddress) {
      Message.error({
        message: "请输入仓库地址",
        duration: 2000,
      });
      return;
    }
    if (!this.currentTransshipDeliveryInfo.warehouseName) {
      Message.error({
        message: "请输入仓库名称",
        duration: 2000,
      });
      return;
    }
    saveTransshipDeliveryInfo(
      this.currentRow.id,
      this.currentTransshipDeliveryInfo
    ).then(() => (this.transshipDeliveryInfoDialogVisible = false));
    this.getList();
  }

  // 配置柜型
  private configContainerTypeDialogVisible = false;
  private configTransshipDeliveryDialogVisible = false;
  private configTransshipDeliveryDialogVisibleTitle = "驳货出库单";
  private configContainerTypeDialogEditable = false;
  private containerTypeConfigurationInfo: ContainerTypeConfigurationInfo =
    new ContainerTypeConfigurationInfo();
  private henganLoadingPlanTransshipInfo: HenganLoadingPlanTransshipInfo =
    new HenganLoadingPlanTransshipInfo();

  private showConfigContainerTypeDialog(
    row: HenganLoadingPlanTableRowData,
    configurationEditable = true
  ) {
    this.currentRow = row;
    this.configContainerTypeDialogEditable = configurationEditable;
    this.configContainerTypeDialogVisible = true;
    this.getContainerTypeConfigurationInfo();
  }

  private showTransshipDeliveryInfoDialog(
    row: HenganLoadingPlanTableRowData,
    edit: boolean,
    title: string
  ) {
    this.editTransship = edit;
    getTransshipInfoForWarehouse(row.id).then((res: any) => {
      this.henganLoadingPlanTransshipInfo = res;
    });
    this.configTransshipDeliveryDialogVisible = true;
    this.configTransshipDeliveryDialogVisibleTitle = title;
  }

  private gotoDocumentFlow(data) {
    this.$router.push({
      name: "DocumentFlow",
      params: { type: "HENG_AN_LOADING_PLAN", documentId: data.id },
    });
  }

  private getContainerTypeConfigurationInfo() {
    getContainerTypeConfigurationInfoForWarehouse(this.currentRow.id).then(
      (res: any) => {
        this.containerTypeConfigurationInfo = res;
      }
    );
  }

  private async onSaveLoadingInfos(
    createDeliveryList: boolean,
    loadingInfos: LoadingInfo[]
  ) {
    const request: ConfigContainerTypeRequest =
      new ConfigContainerTypeRequest();
    request.henganLoadingPlanId = this.currentRow.id;
    request.createDeliveryList = createDeliveryList;
    request.loadingInfos = loadingInfos.map((value) => {
      const r: CreateLoadingInfoRequest = new CreateLoadingInfoRequest();
      Object.assign(r, value);
      r.henganCustomsPackingIds = value.customsPackingSet.map(
        (value) => value.id
      );
      r.containerTypeId = value.containerType?.id || value.containerTypeId;
      return r;
    });
    await saveLoadingInfosForWarehouse(request);
    this.configContainerTypeDialogVisible = false;
    await this.getList();
  }

  private async onDeleteLoadingInfo(loadingInfoId: string) {
    await deleteLoadingInfosForWarehouse(loadingInfoId);
    this.getContainerTypeConfigurationInfo();
    this.getContainerTypeConfigurationInfo();
  }

  // 备货确认
  private confirmStockUpDialogVisible = false;
  private isHandleException = false;
  private selectGroupAll = false;
  private selectedCustomsPackingIds: string[] = [];
  private henganLoadingPlanPackingInfos: HenganLoadingPlanPackingInfoResponse[] =
    [];

  private showConfirmStockUpDialog(
    row: HenganLoadingPlanTableRowData,
    isHandleException: boolean
  ) {
    this.isHandleException = isHandleException;
    this.currentRow = row;
    this.henganLoadingPlanPackingInfos = [];
    this.confirmStockUpDialogVisible = true;
    this.getPackingInfos();
  }

  private getPackingInfos() {
    if (this.isHandleException) {
      getHenganLoadingProblemPackingInfos(this.currentRow.id).then(
        (res: any) => {
          this.henganLoadingPlanPackingInfos = res;
        }
      );
    } else {
      getHenganLoadingPlanPackingInfos(this.currentRow.id).then((res: any) => {
        this.henganLoadingPlanPackingInfos = res;
      });
    }
  }

  private async onSelectionChange() {
    await this.getList();
    this.getPackingInfos();
  }

  private calculateVolume(packingVolume: PackingVolume) {
    return new PackingVolume(
      packingVolume.length,
      packingVolume.width,
      packingVolume.height
    ).calculateVolumeNoDecimalProcessing();
  }

  private handleConfirm(customsPacking: any) {
    console.log('打印一下返回的字段',customsPacking)
    this.$confirm("确定" + this.confirmTitle() + "吗").then(async (_) => {
      if (this.isHandleException) {
        await confirmException(customsPacking.id);
      } else {
        await confirmStockUp(this.currentRow.id, [customsPacking.id]);
      }
      this.getPackingInfos();
      await this.getList();
    });
  }

  confirmTitle() {
    return this.isHandleException ? "异常" : "备货";
  }

  private selectGroup(row, index) {
    this.selectGroupAll = !this.selectGroupAll;
    row.children
      .filter((c) => {
        if (c.state.canConfirmStockUp) {
          return c;
        }
      })
      .map((c) => this.toggleSelection(c, this.selectGroupAll, index));
    this.toggleSelection(row, this.selectGroupAll, index);
  }

  private toggleSelection(row, select, index) {
    const comp = this.$refs.confirmStockUpComponent[index] as any;
    comp.$refs.districtTable.toggleRowSelection(row, select);
  }

  private renderCusAbbr(prop, row) {
    if (row.pcNames && row.pcNames.length > 0){
      return `[${row.pcNames}]${prop}`
    }
    return prop
  }

   private checkHenganLoadingPlanDetail(id:string) {
    this.$router.push({
      name: "HenganLoadingPlanDetail",
      params: { id: id }
    });
  }

  private shownCancelPopoverRowId:string = null;
  private cancelPrepareGoodsLoading = false;
  private async cancelPrepareGoods(rowId:string) {
    this.cancelPrepareGoodsLoading = true;
    try {
      await cancelPrepareGoods(rowId);
      this.shownCancelPopoverRowId = null;
      await this.getList();
    }catch (e) {
      this.$message.error(e)
    }finally {
      this.cancelPrepareGoodsLoading = false;
    }
  }
}

class HenganLoadingPlanTableRowData {
  id: string;
  code: string;
  customerAbbr: string;
  createdAt: Date;
  state: { name: string; desc: string };
  remark: string;
  transshipDelivery: boolean;
  transshipDeclaration: boolean;
  shippingOrderId: string;
  shippingOrderCode: string;
  logisticsClerkName: string;
  logisticsClerkId: string;
  deliveryListId: string;
  loadingInOneOrMorePlaces: string;
  containerTypeInfos: string[];
  deliveryCreatedDate: string;
}

class TransshipDeliveryInfo {
  warehouseAddress: string;
  warehouseName: string;
  contacts: string;
  contactInformation: string;
  transshipWarehouseDeliveryNoteCode: string;
  remark: string;
  logisticsCompany: string;
  licensePlateNumber: string;
  driverTel: string;
}

export class ConfigContainerTypeRequest {
  henganLoadingPlanId: string;
  createDeliveryList = false;
  loadingInfos: CreateLoadingInfoRequest[] = [];
}

export class CreateLoadingInfoRequest {
  id: string;
  containerTypeId: string;
  containerNumber: string;
  sealNumber: string;
  logisticsCompany: string;
  licensePlateNumber: string;
  driverTel: string;
  remark: string;
  henganCustomsPackingIds: string[];
}

class HenganLoadingPlanTransshipInfo {
  henganLoadingPlanId: string;
  code: string;
  customerAbbreviation: string;
  customerCode: string;
  warehouseName: string;
  warehouseAddress: string;
  contacts: string;
  contactInformation: string;
  logisticsCompany: string;
  licensePlateNumber: string;
  driverTel: string;
  transshipWarehouseDeliveryNoteCode: string;
  remark: string;
  customsPackingSet: CustomsPackingModel[] = [];
}
